import { statisticOrientations } from '@/common/components/Statistic/constants'

import * as Styles from './styles'

const StatisticGroup = ({ children, orientation = statisticOrientations.horizontal, className }) => {
  return (
    <Styles.Container role="group" orientation={orientation} className={className}>
      {children}
    </Styles.Container>
  )
}

export default StatisticGroup
